import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { initialSyncMiddleware } from "../middleware/conflictCaseMiddleware";
import { Outlet } from "react-router";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { authActions } from "../store/authSlice";
import logger from "../utils/logger";

const InitialSync = () => {
  const dispatch = useAppDispatch();
  const { pid, email, expires_at } = useAppSelector((state) => state.auth);

  let currTime = Math.floor(new Date().getTime() / 1000);
  const isMockAuth = process.env.REACT_APP_MOCK_AUTH === "true";
  const mockIsAdmin =
    isMockAuth &&
    process.env.REACT_APP_MOCK_USER_ADMIN &&
    process.env.REACT_APP_MOCK_USER_ADMIN === "true";

  const userDataLoadedFromStorage =
    pid !== "" && email !== "" && expires_at > currTime;

  logger.log({
    userDataLoadedFromStorage,
    isMockAuth,
  });

  useEffect(() => {
    if (isMockAuth) {
      // Set mock user data for development
      const mockUser = {
        profile: {
          sub: "mock-user-123",
          email: "developer@example.com",
          nickname: "Mock Developer",
          name: "Mock Developer",
          exp: Math.floor(Date.now() / 1000) + 90000,
          custom_attributes: {
            provisionerId: "mock-provisioner-123",
            userRole: mockIsAdmin ? "Operations Engineer" : null, // Make user an admin
            userProfile: "standard",
            cidClientSuffix: "mock-cid",
            ncheckClientSuffix: "mock-ncheck",
            nviewClientSuffix: "mock-nview",
          },
        },
        access_token: "mock-access-token",
        token_type: "Bearer",
        expires_at: Math.floor(Date.now() / 1000) + 90000,
      };

      dispatch(authActions.storeUser(mockUser as any));
      dispatch(initialSyncMiddleware());
    } else if (userDataLoadedFromStorage) {
      dispatch(initialSyncMiddleware());
    }
  }, [userDataLoadedFromStorage, isMockAuth, dispatch]);

  return (
    <>
      <Outlet />
    </>
  );
};

export default InitialSync;
